export default __webpack_public_path__ + "static/media/rebeca.a45f1a95.jpg";